module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9de-200d-2640-fe0f.5deffcb0.svg";